<template>
  <div>
    <FormSection title="2. Please direct my gift to:">
      <div class="directgift__section">
        <div class="directgift__option">
          <input
            id="needed"
            name="giftdirect"
            type="radio"
            class="frequency"
            @click="customSelected = false"
          />
          <FormLabel for="needed" value="needed"
            >Please use my gift where it is needed most</FormLabel
          >
        </div>
        <div class="directgift__option">
          <input
            id="program"
            type="radio"
            name="giftdirect"
            class="frequency"
            @click="customSelected = true"
          />
          <FormLabel for="program" value="program">Please direct my gift to:</FormLabel>
        </div>
      </div>

      <FormRow class="designation" v-if="customSelected">
        <FormCol field="applications.0.department" :showLabel="false">
          <FormSelect>
            <option selected="selected" value="OU">Select a Designation</option>
            <option value="CommunalResearch">Center for Communal Research</option>
            <option value="CommunityProjectsAndPartnerships">
              Community Projects and Partnership
            </option>
            <option value="IsraelFreeSpirit">Israel Free Spirit</option>
            <option value="NCSY">NCSY</option>
            <option value="NCSY_Alumni">NCSY Alumni</option>
            <option value="Advocacy">OU Advocacy</option>
            <option value="ReliefFunds">OU Disaster Relief Fund</option>
            <option value="ImpactAccelerator">OU Impact Accelerator</option>
            <option value="OUIsrael">OU Israel</option>
            <option value="OUPress">OU Press</option>
            <option value="JLIC">OU-JLIC</option>
            <option value="OU_Torah">OU Torah</option>
            <option value="SynagogueInitiatives">Synagogue Services</option>
            <option value="TeachCoalition">Teach Advocacy Network</option>
            <option value="WomensInitative">The Women's Initiative</option>
            <option value="Yachad">Yachad</option>
          </FormSelect>
        </FormCol>
      </FormRow>
    </FormSection>
    <div v-if="customSelected">
      <FormSection v-if="getValue('applications.0.department') == 'IsraelFreeSpirit'">
        <p>
          Israel Free Spirit, an official trip organizer of Birthright Israel, provides
          free trips to young adults 18-26 years old from various Jewish backgrounds.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'NCSY'">
        <p>
          NCSY is the premier organization dedicated to connect, inspire and empower
          Jewish teens and encourage passionate Judaism through Torah and tradition.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'NCSY_Alumni'">
        <p>
          NCSY Alumni fosters a continuing relationship with thousands of NCSY graduates
          as they take their place in Jewish life.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'Advocacy'">
        <p>
          The OU Advocacy Center is the non-partisan public policy arm of the nation's
          largest Orthodox Jewish organization‚ representing nearly 1,000 congregations
          nationwide, and leads the OU's advocacy efforts in Washington, DC, and state
          capitals.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'ReliefFunds'">
        <p>
          In times of crisis, the OU mobilizes its resources to support relief and
          recovery efforts in affected communities.
        </p>
      </FormSection>
      <FormSection
        v-else-if="getValue('applications.0.department') == 'ImpactAccelerator'"
      >
        <p>
          An 18-month program built on mentorship-based growth and early-stage funding for
          Jewish nonprofit entrepreneurs.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'OUIsrael'">
        <p>
          From a hub of Torah study in Jerusalem to centers for at-risk youth across the
          country, OU Israel provides vital support to the citizens of Israel.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'JLIC'">
        <p>
          On 21 college campuses, the OU's Jewish Learning Initiative on Campus (OU-JLIC)
          program involves thousands of Jewish students in Torah learning and Jewish life.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'OU_Torah'">
        <p>
          Provides a broad array of Torah study opportunities for both those new to
          learning and those with many years of proficiency.
        </p>
      </FormSection>
      <FormSection
        v-else-if="getValue('applications.0.department') == 'SynagogueInitiatives'"
      >
        <p>
          The Department of Community Engagement provides vision, leadership, and
          programmatic support to Orthodox communities and congregations throughout North
          America.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'TeachCoalition'">
        <p>
          The Teach Advocacy Network is dedicated to securing government support to ensure
          that Jewish schools are safe and fairly funded.
        </p>
      </FormSection>
      <FormSection
        v-else-if="getValue('applications.0.department') == 'WomensInitative'"
      >
        <p>
          The Women's Initiative aims to create and promote women's programming in the
          areas of Torah study, community leadership, spiritual, personal and professional
          growth, health and social well-being for women of all ages.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'Yachad'">
        <p>
          Yachad champions the inclusion of thousands of individuals with disabilities in
          Jewish life each year.
        </p>
      </FormSection>
      <FormSection
        v-else-if="
          getValue('applications.0.department') == 'CommunityProjectsAndPartnerships'
        "
      >
        <p>
          Community Projects & Partnerships aims to elevate communal values surrounding
          crucial areas of challenge that affect the orthodox Jewish community.
        </p>
      </FormSection>
      <FormSection
        v-else-if="getValue('applications.0.department') == 'CommunalResearch'"
      >
        <p>
          The Center for Communal Research uses data to help the OU and other Jewish
          organizations better understand and serve the Jewish people. Our vision is a
          Jewish community that is both values-driven and evidence-informed, harnessing
          the power of data to identify its most pressing needs and most effective
          solutions.
        </p>
      </FormSection>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();

    const customSelected = ref(false);

    watch(
      () => form.value.applications[0].department,
      (val) => {
        if (val == "ImpactAccelerator" || !val) {
          setValue("applications.0.campaign", "EOFY24");
        } else {
          setValue("applications.0.campaign", "EOFY24");
        }
      }
    );

    return {
      getValue,
      customSelected,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 100%;
    max-width: 100%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
.directgift__section {
  margin-bottom: 15px;
}

.directgift__option {
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>
